import { isFeatureEnabled, type AccountFeature } from '@/api/accountConfig';
import { useAuth } from '@/contexts/AuthContext';
import { useAccountConfigQuery } from './useAccountConfigQuery';

/** Feature switches for the signed-in account. */
export const useAccountConfig = () => {
  const { user } = useAuth();
  const { data, isPending } = useAccountConfigQuery(user);
  const features = data?.features;

  return {
    features: features ?? {},
    isPending: Boolean(user) && isPending,
    isFeatureEnabled: (feature: AccountFeature) => isFeatureEnabled(features, feature),
  };
};
